export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40424d52d5f017ffe20c44d7622e950c0560182558&name=revalidateCommunity!'